import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "onSwitch", "wide", "defaultActiveTabIndex", "activeTabIndex", "onActiveTabIndexChange", "removePaddingLeft", "removePaddingRight", "defaultActiveTab"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect } from 'react';
import { preProcessTabChildren } from '../utils';
import { useControlledState } from '../../../system';
export var useTabs = function useTabs(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      onSwitch = _ref.onSwitch,
      wide = _ref.wide,
      defaultActiveTabIndex = _ref.defaultActiveTabIndex,
      activeTabIndex = _ref.activeTabIndex,
      onActiveTabIndexChange = _ref.onActiveTabIndexChange,
      removePaddingLeft = _ref.removePaddingLeft,
      removePaddingRight = _ref.removePaddingRight,
      _ref$defaultActiveTab = _ref.defaultActiveTab,
      defaultActiveTab = _ref$defaultActiveTab === void 0 ? 0 : _ref$defaultActiveTab,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useControlledState = useControlledState(defaultActiveTabIndex !== undefined ? defaultActiveTabIndex : defaultActiveTab, activeTabIndex, onActiveTabIndexChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      currentlyActiveTab = _useControlledState2[0],
      setCurrentlyActiveTab = _useControlledState2[1];

  useEffect(function () {
    if (onSwitch && defaultActiveTab) {
      onSwitch(defaultActiveTab);
    }
  }, []);
  var handleClick = useCallback(function (event, tabIndex, contentValue) {
    setCurrentlyActiveTab(tabIndex);

    if (onSwitch && contentValue !== undefined) {
      onSwitch(contentValue);
    }
  }, [onSwitch]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: ref,
      wide: wide,
      disabled: disabled,
      children: preProcessTabChildren(children),
      removePaddingLeft: removePaddingLeft,
      removePaddingRight: removePaddingRight
    }),
    contextValue: {
      currentlyActiveTab: currentlyActiveTab,
      wide: wide,
      handleClick: handleClick
    },
    disabled: disabled
  };
};